module.exports = __webpack_public_path__ + "0ae513058c2852740c3003d5763b22ee.png";